import { useResolvedLayout } from '@/shared/lib/layout';
import { DesktopBriefingScreen } from './DesktopBriefingScreen';
import { MobileBriefingScreen } from './MobileBriefingScreen';
import type { BriefingScreenProps } from './types';

/**
 * Shared briefing/lobby shell — cork-stage frame with a suspect roster
 * column, a right-hand aside column on desktop+tablet, and a sticky
 * header+footer on mobile. The standalone setup screen and the online
 * lobby reuse this layout; only the slot content differs.
 */
export const BriefingScreen = (props: BriefingScreenProps) => {
  const layout = useResolvedLayout();
  if (layout === 'mobile') {
    return (
      <MobileBriefingScreen
        board={props.board}
        mobileHeader={props.mobileHeader}
        mobileFooter={props.mobileFooter}
      />
    );
  }
  return (
    <DesktopBriefingScreen
      board={props.board}
      aside={props.aside}
      desktopTopBar={props.desktopTopBar}
    />
  );
};
